// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2kjnU","content":"styles_content__GRbB5","tableWrap":"styles_tableWrap__1iHnl"};